import SecurityRule from './security.rule';
import { sha256 } from '@assets/js/imaios-global/imaios-global';
import { TimeManagerService } from '../../TimeManagerService';

/**
 * @param {string} url
 * @param {string} content
 * @param {string} nonce
 * @return {{counter: string, digest: string}}
 */
function generateHash(url, content, nonce) {
	const prefixPattern = '000';
	let counter = 0;
	let hashResult = '';
	const digest = sha256(content);

	while (!hashResult.startsWith(prefixPattern) && counter < 50000) {
		hashResult = sha256(url + digest + nonce + counter);
		counter++;
	}
	counter = counter - 1;

	return {
		counter,
		digest
	};
}

/**
 * -> is the time of server /api/time of your local  docker stack nginx (if you pass by https://www.imaios.docker)
 * OR
 * -> is the time of fastly server /api/time (if you pass by https://www.imaios.com)
 * @param {string} url
 * @param {string} content
 * @param {number} nonce_size
 * @param {number} serverTime
 * @return {{'x-im-powdigest': *, 'x-im-pownonce': string, 'x-im-powcounter': *, 'X-Requested-With': string, 'content-type': string, 'x-im-proxy': string, 'x-im-powts': number}} headers
 */
function generatePow(url, content, nonce_size, serverTime) {
	const endSubstring = 2 + nonce_size;

	// Get nonce
	const nonce1 = Math.random().toString(36).substring(2, endSubstring);
	const nonce2 = Math.random().toString(36).substring(2, endSubstring);
	const nonce = nonce1.concat(nonce2).substring(2, endSubstring);

	const { counter, digest } = generateHash(url, content, nonce);
	return {
		'x-im-powts': serverTime, // do not use the time of current device: Math.floor(serverTime/1000);
		'x-im-pownonce': nonce,
		'x-im-powcounter': counter,
		'x-im-powdigest': digest,
		'x-im-proxy': `host=${location.host}`,
		'content-type': 'application/json',
		'X-Requested-With': 'XMLHttpRequest'
	};
}


class PowRule extends SecurityRule {
	constructor(manager, settings = {}) {
		super(manager, settings);
		const rulesElement = this.getForm().querySelector('[data-rule="security"][data-name="pow"]');

		this.contentType = rulesElement.getAttribute('data-content-type') || 'application/json';

		this.url = settings.url || this.getForm().action;
		this.nonce_size = settings['nonce-size'] || 10;
	}

	async getBodyString() {
		if (this.contentType === 'application/x-www-form-urlencoded') {
			return new URLSearchParams(await this.manager.getBody()).toString();
		} else {
			return JSON.stringify(await this.manager.getBody());
		}
	}

	async apply(settings) {
		const body = await this.getBodyString();
		const form = this.getForm();
		form.options = {};

		if (typeof window.getHeadersPolyfill === 'function') {
			await window.getHeadersPolyfill();
		}

		const singleton = await TimeManagerService.getInstance();
		let serverTime = singleton.getTime()
		form.options.headers = new Headers(
			generatePow(this.url, body, this.nonce_size, serverTime)
		);

		form.options.headers.set('content-type', this.contentType);

		form.options.body = body;
		form.options.method = 'POST';
		return true;
	}
}

export default PowRule;
